import React from 'react';
import '@elastic/eui/dist/eui_theme_light.css';
import { EuiText, EuiFlexGroup, EuiFlexItem, EuiSpacer, EuiPageTemplate, EuiPageHeader } from '@elastic/eui';
import styled from 'styled-components';
import { Header } from '../components/header';
import { Footer } from '../components/footer';

const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-gap: 0 10px;
    padding: 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '• ';
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
class Journal1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            isModalVisible: false,
            files: {},
            uploadDisabled: true,
            selection: [],
            columns: [],
            AlertText: "",
            AlertType: "error",
            journal1Objective:"To provide a robust & rational methodology for prediction of characteristic compressive strength of concrete using MDA",
            journal1Key:['Rational and robust methodology to predict the characteristic compressive strength of concrete', 'Incorporation of real-time changes in mix proportion', '6 rational equations generated for 6 different mix proportions', '10 sources of data all over the globe considered for study', 'Developed 4 machine learning models for prediction of compressive strength of concrete', 'Deployed the MDA formulation into a web application for field deployment', 'Compared each model for dimensional homogeneity, dimensional reduction and user-friendly formulation'],
            journal1Value:['Enhancing in innovation quotient', 'Ownership and Leadership', 'Problem Solving'],    
    }
    }

    render() {

        return (
            <>
                <EuiPageTemplate>
                    <EuiPageHeader><Header /></EuiPageHeader>
                <EuiFlexGroup gutterSize='xl'>
                <EuiFlexItem>
                        <EuiSpacer />
                        <EuiText><h2><font face='Segoe UI'>Prediction of Mix Based Compressive Strength of concrete using Modified Dimensional Analysis</font></h2></EuiText>
                        <EuiSpacer size='m' />
                        <EuiText><h5><font face='Segoe UI'>Mentor :- Dr. Hemant Dhonde, Dr. Shilpa Patil&emsp; &emsp; &emsp; &emsp; &emsp;&emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp;March 2020 – Present</font></h5></EuiText>
                        <EuiSpacer size='m' />
                        <EuiText><b>Research Objectives</b><br/>
                        {this.state.journal1Objective}<EuiSpacer/>
                        <b>Project Highlights</b>
                        <StyledText><ul className="skills-list">
                        {this.state.journal1Key && this.state.journal1Key.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText>
                        <b>Value Additions</b>
                        <StyledText><ul className="skills-list">
                        {this.state.journal1Value && this.state.journal1Value.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText>
                        </EuiText>
                </EuiFlexItem>
                </EuiFlexGroup>
            <Footer /></EuiPageTemplate>
            </>
        )
    }
};

export { Journal1 }